import { securedApiRequest } from "./SecuredApi";

/**
 * Activates a trip after a successful payment.
 * @param {string} reference - The trip reference ID.
 * @returns {Promise<Object>} Response data or throws an error.
 */
export const activateTrip = (reference) => {
    return securedApiRequest("/activate-trip/", "POST", { reference });
};

/**
 * Cancels a trip after a failed or canceled payment.
 * @param {string} reference - The trip reference ID.
 * @returns {Promise<Object>} Response data or throws an error.
 */
export const cancelTrip = (reference) => {
    return securedApiRequest("/cancel-trip/", "POST", { reference });
};
